export default "__VITE_ASSET__DjEl97tE__"